import { formatarFracaoPercentual } from '@/lib/format';

/**
 * Delta da API ("b - a") como texto com sinal. Nao calcula: so acrescenta "+" a um valor positivo; o resto
 * (sinal negativo, casas) vem de `formatarFracaoPercentual`.
 */
export function sinalizar(texto: string, valor: string | null | undefined): string {
  if (valor === null || valor === undefined) return '—';
  return valor.trim().startsWith('-') || texto === '—' ? texto : `+${texto}`;
}

/** Delta de lucro (fracao) em pontos percentuais: "+1,50%" (a API ja entregou a diferenca). */
export function deltaLucro(fracao: string | null | undefined): string {
  return sinalizar(formatarFracaoPercentual(fracao), fracao);
}
